import * as defaults from './defaults';
import * as Mutation from './mutation';

const resolvers = {
	Mutation,
};

export { resolvers, defaults };
